import { Component, OnInit, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { isObservable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { FormlyModule } from '@ngx-formly/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DestroyRef, inject } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-formly-auto-complete',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Select, FormlyModule],
  template: `
    <div class="field">
      <label [for]="field.key" *ngIf="to.label">
        {{ to.label }}
        <span *ngIf="to.required" class="text-red-500">*</span>
      </label>
      <p-select
        appendTo="body"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [optionLabel]="to.optionLabel || 'label'"
        [options]="items"
        [dataKey]="'storageName'"
        [style]="{ minWidth: '100%' }">
        <!-- Payroll mintájára egyszerű template -->
        <ng-template let-storage pTemplate="item">
          <div class="flex justify-between align-items-center">
            <span class="font-medium">{{ storage.storageName }}</span>
            <span
              class="text-sm px-2 py-1 rounded"
              [class.bg-green-100]="storage.amount > 0"
              [class.bg-red-100]="storage.amount === 0"
              [class.text-green-800]="storage.amount > 0"
              [class.text-red-800]="storage.amount === 0">
              {{
                storage.amount > 0
                  ? storage.amount + ' db készleten'
                  : 'Nincs készlet'
              }}
            </span>
          </div>
        </ng-template>
      </p-select>
    </div>
  `,
})
export class FormlyStorageSelectComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  private readonly destroyRef = inject(DestroyRef);

  items: {
    storageName: string;
    amount: number;
    serialNumbers: string[];
  }[] = [];

  ngOnInit(): void {
    const options = this.field.templateOptions?.options;

    if (isObservable(options)) {
      options
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((storages) => {
          this.items = this.processStorageOptions(storages);
        });
      return;
    }

    this.items = this.processStorageOptions(options || []);
  }

  private processStorageOptions(storages: any[]): any[] {
    console.log('=== STORAGE PROCESSING DEBUG ===');
    console.log('Input storages:', storages);

    if (!Array.isArray(storages)) {
      console.log('Not an array, returning empty');
      return [];
    }

    const processed = storages.map((storage) => {
      const result = {
        ...storage,
        label: `${storage.storageName} (${storage.amount} db)`, // Select display
      };
      console.log('Processed storage:', result);
      return result;
    });

    console.log('Final processed storages:', processed);
    return processed;
  }

}
